const content = {
  marginLeft: '10px',
  marginTop: '10px',
}

const toggle = {
  marginRight: '5px',
  cursor: 'pointer',
  width: '8px',
}

const list = {
  marginLeft: '25px',
  marginBottom: '15px',
}

const formGroup = {
  marginBottom: '5px',
}

const checkbox = {
  paddingTop: '0px',
}


export default { content, toggle, list, formGroup, checkbox, };



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Radio/components/RadioStationsGroup/style.js